<div class="container-fluid">

  <div class="row m-0">
    <div class="col-lg-12">
      <h2>@if (bathrooms) {
        <span>{{bathrooms.length}}</span>
      } Bathrooms(s)</h2>
    </div>
    <div class="col-lg-12">
      <button mat-button style="color:green; padding: 0;" (click)="openFormAdd()">
        <mat-icon style="font-size:140%">add_circle</mat-icon> Add Bathroom
      </button>
    </div>
  </div>

  <div class="row m-0">
    @for (bathroom of bathrooms; track bathroom; let i = $index) {
      <div class="col-lg-12">
        <h2>Bathroom {{i+1}}</h2>
        <app-bathroom-form [shortTermRentalId]="shortTermRentalId" [featuresList]="featuresList" [bathroom]="bathroom" (doAdd)="addBathroom($event)" (doUpdate)="updateBathroom($event)"
        (doDelete)="deleteBathroom($event)"></app-bathroom-form>
        <br><br>
        <mat-divider></mat-divider>
        <br><br>
      </div>
    }
  </div>
</div>
